import HospitalEdit from './HospitalEdit';

export default HospitalEdit;
